import React from 'react';
import { useRouter } from 'next/router';
import ProductDetail from '../components/Products/ProductDetail';
import productQuery from '../lib/queries/products/productQuery.graphql';
import withApollo from '../lib/apollo';
import redirectRouteToDomain from '../lib/redirectRouteToDomain';
import {
  productDetailImageConfigurations,
} from '../lib/imageConfigurations';

const CompanyProfileProductPage = () => {
  const { query: { id, slug } } = useRouter();
  const variables = {
    slug,
    id: Number(id),
    imageConfigurations: productDetailImageConfigurations,
  };

  return (
    <ProductDetail
      query={productQuery}
      variables={variables}
      errorMessage="Error loading this product info"
      passErrors={['Access denied']}
      backToProductsRoute="company-profile-products"
      {...variables}
    />
  );
};

CompanyProfileProductPage.getInitialProps = redirectRouteToDomain(
  'company-profile-product',
);

export default withApollo(CompanyProfileProductPage);
